import * as TYPES from './types';
export default {
    [TYPES.SET_INFO](payload) {
        this.info = payload;
    },
    [TYPES.SET_EST_PRICE](payload) {
        this.estPrice = payload;
    },
    [TYPES.SET_DIFF_PRICE](payload) {
        this.diffPrice = payload;
    },
};
